import { memoizeFunction } from '@agilepoint/utils-common';
import styled, { css } from 'styled-components';
import { selectThemeSemantics } from '../../../styling';
import { RichTextEditorState } from '../theme';
import { getStyles } from '../utils';

interface IEditorProps {
    $disabled?: boolean;
    $error?: boolean;
}

const getRichTextEditorStyleByState = memoizeFunction((state: RichTextEditorState) => css`
        background-color: ${({ theme }) => getStyles(theme, state).backgroundColor} !important;
        color: ${({ theme }) => getStyles(theme, state).foregroundColor} !important;
    `);

const getRichTextEditorStyle = memoizeFunction((state: RichTextEditorState) =>
    ({ $disabled, $error }: IEditorProps) => getRichTextEditorStyleByState($disabled ? 'disabled' : ($error ? 'error' : state)));

export const EditorContainer = styled.div.attrs({
    className: String('ap-richTextEditor-editor')
}) <IEditorProps>`
    width: 100%;
    height: 100%;
    border: none;
    outline: 0;
    box-sizing: border-box;
    overflow: auto;
    padding: ${selectThemeSemantics(({ gap }) => gap.m)};
    ${getRichTextEditorStyle('default')}
    &:hover {
        ${getRichTextEditorStyle('hovered')};
    }
    &:focus-within, :active {
        ${getRichTextEditorStyle('focussed')};
    };

    code {
        display: block;
        background-color: ${selectThemeSemantics(({ palette }) => palette.neutralTertiary)};
    }
`;
